// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/pages/Major/List/index.less
// module id = 270
// module chunks = 0